import { render } from "./PhotoGalleryForm.vue?vue&type=template&id=23a83158&scoped=true"
import script from "./PhotoGalleryForm.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryForm.vue?vue&type=script&lang=js"

import "./PhotoGalleryForm.vue?vue&type=style&index=0&id=23a83158&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a83158"]])

export default __exports__